const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/freegames.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/freegames")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async () => {
    throw redirect({
      to: "/{-$locale}/freebies",
      search: {
        developerDisplayName: undefined,
        publisherDisplayName: undefined
      }
    });
  }
});